"use client"

import { useTranslations } from "@/lib/intl/use-translations"

interface Props {
  onClick: () => void
}

export function BackButton({ onClick }: Props) {
  const t = useTranslations("quiz")
  return (
    <button
      onClick={onClick}
      className="type-body-sm text-neutral-600 underline-offset-2 hover:underline"
    >
      {t("back")}
    </button>
  )
}
